import { render, staticRenderFns } from "./MemberDetail.vue?vue&type=template&id=6d7c1b4d&scoped=true&"
import script from "./MemberDetail.vue?vue&type=script&lang=js&"
export * from "./MemberDetail.vue?vue&type=script&lang=js&"
import style0 from "./MemberDetail.vue?vue&type=style&index=0&id=6d7c1b4d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7c1b4d",
  null
  
)

export default component.exports